import React, { useState } from 'react';
import { Alert, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { EntityEditDialog } from '@lp/lp-ui';

interface BulkEnableDisableDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (enable: boolean) => void;
}

const BulkEnableDisableDialog: React.FC<BulkEnableDisableDialogProps> = ({ open, onClose, onSave }) => {
    const [selected, setSelected] = useState<string>('');

    const handleClose = () => {
        setSelected('');
        onClose();
    };

    const handleSave = () => {
        onSave(selected === 'enable');
        setSelected('');
    };

    return (
        <EntityEditDialog
            open={open}
            maxWidth="sm"
            fullWidth
            title="Enable/Disable Users"
            handleClose={handleClose}
            handleSave={handleSave}
            editing={true}
            disableSave={!selected}
        >
            <Alert severity="info" sx={{ mb: 2 }}>
                This action will be executed in the background and it may take some time for all changes to take effect.
            </Alert>
            <FormControl>
                <FormLabel>Action</FormLabel>
                <RadioGroup value={selected} onChange={(e) => setSelected(e.target.value)}>
                    <FormControlLabel value="enable" control={<Radio />} label="Enable" />
                    <FormControlLabel value="disable" control={<Radio />} label="Disable" />
                </RadioGroup>
            </FormControl>
        </EntityEditDialog>
    );
};

export default BulkEnableDisableDialog;
